import axios from "axios";

const store = {
    state: {},

    getters: {},

    mutations: {},

    actions: {
        storeCrashAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/crash/store`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        updateCrashAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/crash/update`, payload)
                    .then((res) => {
                        resolve(res.data.crash);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findCrashsAction() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/crash/find-all`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deletePhotoCrashAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/crash/delete-photo`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    },
};

export default store;
